import type { EntityDiscoveryItem } from '../../api/types';

export type EntityCardinalityRoute =
  | { kind: 'error'; message: string }
  | { kind: 'auto-select'; entity: EntityDiscoveryItem }
  | { kind: 'select' };

export function routeDiscoveredEntities(
  entities: EntityDiscoveryItem[],
  autoSelectSingleEntity: boolean,
): EntityCardinalityRoute {
  if (entities.length === 0) {
    return { kind: 'error', message: 'No readable tables were found in this data source.' };
  }
  if (entities.length === 1 && autoSelectSingleEntity) {
    return { kind: 'auto-select', entity: entities[0] };
  }
  return { kind: 'select' };
}
